/**
 * Bouton d'interface.
 *
 * Une seule règle de cible est portée par la classe `.bouton` (44 px de haut) : elle vaut pour
 * tous les écrans du back-office, y compris ceux qui n'y pensent pas. `enCours` désactive le
 * bouton **et** expose `aria-busy` : c'est ce qui neutralise le double-clic sur publication et
 * sur enregistrement (un second clic ne peut pas partir).
 */
import type { ButtonHTMLAttributes } from 'react';

export type VarianteBouton = 'principal' | 'secondaire' | 'danger' | 'discret';

export interface ProprietesBouton extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variante?: VarianteBouton;
  /** Affiche un indicateur d'activité et désactive le bouton. */
  readonly enCours?: boolean;
  /** Libellé affiché pendant l'activité. */
  readonly texteEnCours?: string;
}

export function Bouton({
  variante = 'principal',
  enCours = false,
  texteEnCours,
  children,
  className,
  disabled,
  type = 'button',
  ...reste
}: ProprietesBouton) {
  const classes = ['bouton', `bouton--${variante}`, className].filter(Boolean).join(' ');
  const libelle = enCours && texteEnCours !== undefined ? texteEnCours : children;
  return (
    <button
      {...reste}
      type={type}
      className={classes}
      disabled={disabled === true || enCours}
      aria-busy={enCours ? true : undefined}
    >
      {enCours ? <span className="tourniquet" aria-hidden="true" /> : null}
      <span className="bouton__libelle">{libelle}</span>
    </button>
  );
}
